import { http } from './http';

export interface AuditQueryRow {
  queryId: string;
  startedAt: string;
  userLogin: string;
  connLabel: string;
  statementType: string | null;
  rowsReturned: number | null;
  rowsAffected: number | null;
  status: string;
  errorMessage: string | null;
  durationMs: number | null;
  matchedRules: string | null;
}

export interface AuditDetailRow extends AuditQueryRow {
  sqlText: string;
  policyDecisions: PolicyDecisionItem[];
}

export interface PolicyDecisionItem {
  ruleId: string;
  ruleVersion: number;
  action: string;
  reason: string | null;
}

export interface AuditListResponse {
  items: AuditQueryRow[];
  total: number;
  page: number;
  pageSize: number;
}

export interface IntegrityCheckResult {
  checked: number;
  broken: number;
  lastHash: string | null;
  checkedAt: string;
}

export const auditApi = {
  listQueries: (params: {
    from?: string;
    to?: string;
    search?: string;
    statementType?: string;
    status?: string;
    page?: number;
    pageSize?: number;
  }) =>
    http.get<AuditListResponse>('/audit/queries', { params }).then(r => r.data),

  getQuery: (queryId: string) =>
    http.get<AuditDetailRow>(`/audit/queries/${queryId}`).then(r => r.data),

  checkIntegrity: () =>
    http.get<IntegrityCheckResult>('/audit/integrity-check').then(r => r.data),
};
